module.exports = __webpack_public_path__ + "static/media/aviatrix-casino.9c0d6db6.png";